import { render, staticRenderFns } from "./indexBanner.vue?vue&type=template&id=5a1fd28c&scoped=true"
import script from "./indexBanner.vue?vue&type=script&lang=js"
export * from "./indexBanner.vue?vue&type=script&lang=js"
import style0 from "./indexBanner.vue?vue&type=style&index=0&id=5a1fd28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fd28c",
  null
  
)

export default component.exports